<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="row">
        <div class="col-lg-4 d-flex">
          <card class="card-eprf">
            <p style="color: #358CCB; font-size: 24px; font-weight: 300">
              JOB DETAILS
            </p>
            <div style="height: 780px; overflow: auto; overflow-x: hidden">
              <p class="new-title">Job Reference No.</p>
              <p class="subtitle">{{ jobno }}</p>

              <p class="new-title" v-if="landvesselflag == 'LAND'">
                Collection Date
              </p>
              <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                Arrival ETA
              </p>
              <p class="subtitle">{{ arrivalETA }}</p>

              <p class="new-title">Service Location</p>
              <p class="subtitle">
                {{ servicelocation }}
              </p>

              <p class="new-title">Service Location Collection</p>
              <p class="subtitle">
                {{ servicelocationcollection }}
              </p>

              <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                Departure (ETD)
              </p>
              <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                {{ departureETD }}
              </p>

              <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                Previous Port
              </p>
              <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                {{ previousPort }}
              </p>

              <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                Next Port
              </p>
              <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                {{ nextPort }}
              </p>

              <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                Last Port When Generated Waste Delivered
              </p>
              <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                {{ lastPortAndDate }}
              </p>

              <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                Last Date When Generated Waste Delivered
              </p>
              <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                {{ lastDate }}
              </p>

              <p class="new-title">Company Name</p>
              <p class="subtitle">{{ companyName }}</p>

              <p class="new-title">Company Address</p>
              <p class="subtitle">{{ companyAddress }}</p>

              <p class="new-title">Phone No. / Fax No.</p>
              <p class="subtitle">{{ phoneNoFaxNo }}</p>

              <p class="new-title">PIC Full Name</p>
              <p class="subtitle">{{ picFullName }}</p>

              <p class="new-title">PIC Phone No. / Fax No.</p>
              <p class="subtitle">{{ picPhoneNoFaxNo }}</p>

              <p class="new-title">PIC Email</p>
              <p class="subtitle">{{ picEmail }}</p>

              <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                Ship Name
              </p>
              <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                {{ shipName }}
              </p>

              <p class="new-title" v-if="landvesselflag == 'VESSEL'">IMO No.</p>
              <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                {{ imoNo }}
              </p>

              <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                Ship Type
              </p>
              <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                {{ shipType }}
              </p>

              <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                Gross Tonnage
              </p>
              <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                {{ grossTonnage }}
              </p>

              <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                Deadweight Tonnage (kg)
              </p>
              <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                {{ deadweightTonnage }}
              </p>

              <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                Owner / Operator Name
              </p>
              <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                {{ owneroperatorname }}
              </p>

              <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                Call Sign
              </p>
              <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                {{ callSign }}
              </p>

              <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                Flag State
              </p>
              <p class="subtitle" v-if="landvesselflag == 'VESSEL'">
                {{ flagState }}
              </p>

              <p class="new-title" v-if="landvesselflag == 'VESSEL'">
                Sustainable Certificates
              </p>

              <div
                v-if="landvesselflag == 'VESSEL' && shipdoc.length !== 0"
                v-for="(file, index) in shipdoc"
                :key="'allship_file' + index"
                class="row"
              >
                <div class="col-lg-8">
                  {{ index + 1 }}.
                  <a :href="file.fileurl">
                    <base-button class="btn-link btn-primary">
                      {{ file.filename }}
                    </base-button>
                  </a>
                </div>
              </div>
              <p
                v-if="landvesselflag == 'VESSEL' && shipdoc.length === 0"
                class="subtitle"
              >
                None
              </p>
            </div>
          </card>
        </div>
        <div class="col-lg-8 d-flex" v-if="generate == false">
          <card class="card-eprf">
            <div class="row" style="display: flex">
              <div class="col-lg">
                <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                  QUOTATION
                </p>
              </div>
              <div
                class="col-lg-3 text-right"
                v-if="landvesselflag == 'VESSEL'"
              >
                <div class="row">
                  <div class="col-lg">Marketing Channel:</div>
                </div>
                <div class="row">
                  <div class="col-lg" style="font-weight: bold">
                    {{ marketingchannel }}
                  </div>
                </div>
              </div>
              <div class="col-lg-3 text-right">
                <div class="row">
                  <div class="col-lg">Cancelled Ref No:</div>
                </div>

                <div class="row" v-if="positionid == 1 || positionid == 2">
                  <div class="col-lg">
                    <el-select
                      v-model="cancelledref"
                      @change="sendCancelledRef()"
                    >
                      <el-option
                        class="select-primary"
                        v-for="(item, index) in cancelledrefs"
                        :key="index"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="row" v-else>
                  <div class="col-lg" style="font-weight: bold">
                    {{ cancelledref }}
                  </div>
                </div>
              </div>
            </div>
            <br />
            <div v-if="(positionid == 1 || positionid == 2) && step == 2">
              <div class="row">
                <div class="col-lg-4">
                  <p class="new-title">
                    Subject Line <span style="color: #EC1B23">*</span>
                  </p>
                  <input
                    type="text"
                    v-model="subjectline"
                    :class="{ 'custom-input': true }"
                  />
                </div>
              </div>
              <br />
              <div
                class="row"
                style="height: 320px; overflow: auto; overflow-x: hidden"
              >
                <div class="col-lg">
                  <el-table
                    :data="quotations"
                    :header-cell-style="{
                      background: '#358DCC',
                      border: 'transparent',
                      'font-size': '14px',
                      'font-weight': '400',
                      color: '#FFFFFF',
                    }"
                    :cell-style="{ fontColor: '#707070' }"
                    :row-style="tableRowClassName"
                    style="color: #707070"
                  >
                    <el-table-column label="NO." width="50" align="center">
                      <div slot-scope="scope">
                        <p
                          style="color: #707070"
                          v-if="scope.row.description != 'GRAND TOTAL'"
                        >
                          {{ scope.$index + 1 }}
                        </p>
                      </div>
                    </el-table-column>

                    <el-table-column
                      :min-width="200"
                      align="center"
                      label="DESCRIPTION"
                      prop="description"
                    >
                      <div slot-scope="{ row }">
                        <div align="left">
                          <div class="row">
                            <div class="col-lg">
                              <p style="color: #A5A5A5">{{ row.description }}</p>

                              <p
                                style="color: #A5A5A5; word-break: break-word"
                                v-if="row.description != 'GRAND TOTAL'"
                              >
                                Waste Sub Type: {{ row.wastesubtype }}
                              </p>

                              <p
                                style="color: #A5A5A5; word-break: break-word"
                                v-if="row.description != 'GRAND TOTAL'"
                              >
                                Transportation Rate:
                              </p>
                              <br />
                            </div>
                          </div>
                        </div>
                      </div>
                    </el-table-column>

                    <el-table-column
                      :min-width="150"
                      align="center"
                      label="RATE"
                      prop="rate"
                    >
                      <div slot-scope="scope">
                        <div class="row">
                          <div
                            class="col-lg-4"
                            style="padding-top: 5px"
                            v-if="scope.row.description != 'GRAND TOTAL'"
                          >
                            RM <span style="color: #EC1B23">*</span>
                          </div>
                          <div class="col-lg">
                            <input
                              type="number"
                              min="0"
                              step=".01"
                              style="color: #707070"
                              v-if="scope.row.description != 'GRAND TOTAL'"
                              :class="{ 'custom-input': true }"
                              v-model="scope.row.rate"
                              @change="rateChange(scope.$index)"
                            />
                          </div>
                          <div class="col-lg-1"></div>
                        </div>
                        <div class="row">
                          <div
                            class="col-lg-4"
                            style="padding-top: 5px"
                            v-if="scope.row.description != 'GRAND TOTAL'"
                          >
                            RM <span style="color: #EC1B23">*</span>
                          </div>
                          <div class="col-lg">
                            <input
                              type="number"
                              min="0"
                              step=".01"
                              style="color: #707070"
                              v-if="scope.row.description != 'GRAND TOTAL'"
                              :class="{ 'custom-input': true }"
                              v-model="scope.row.transportationrate"
                              @change="rateChange(scope.$index)"
                            />
                          </div>
                          <div class="col-lg-1"></div>
                        </div>
                      </div>
                    </el-table-column>

                    <el-table-column
                      :min-width="150"
                      align="center"
                      label="EST. AMOUNT"
                      prop="estamount"
                    >
                      <div slot-scope="{ row }">
                        {{ row.estamount }} {{ row.estunit }}
                      </div>
                    </el-table-column>

                    <el-table-column
                      :min-width="200"
                      align="center"
                      label="AMOUNT "
                      prop="amount"
                    >
                      <div slot-scope="{ row }">
                        <div class="row">
                          <!--kat sini total grand-->
                          <div class="col-lg">RM {{ row.amount }}</div>
                        </div>
                      </div>
                    </el-table-column>
                  </el-table>
                </div>
              </div>

              <!-- future days akan jadi dropdown -->
              <br />
              <div class="row">
                <div class="col-lg-12">
                  <div class="row">
                    <div class="col-lg">
                      <div class="row">
                        <div class="col-lg-4">
                          <p class="new-title">
                            Delivery Term <span style="color: #EC1B23">*</span>
                          </p>
                        </div>
                        <div class="col-lg-2 text-center">
                          <input
                            style="text-align: center"
                            type="number"
                            min="0"
                            v-model="deliveryterm"
                            :class="{ 'custom-input': true }"
                          />
                        </div>
                        <div
                          class="col-lg-3 text-left"
                          style="padding-bottom: 5px"
                        >
                          <el-select
                            class="select-info tab select-width"
                            placeholder="Select"
                            v-model="selects.day"
                            style="border-bottom: 1px solid lightgray"
                          >
                            <el-option
                              v-for="option in selects.days"
                              class="select-info"
                              :value="option.value"
                              :label="option.label"
                              :key="option.value"
                            ></el-option>
                          </el-select>
                          <!-- <p class="new-title">Days</p> -->
                        </div>
                      </div>
                    </div>

                    <div class="col-lg">
                      <div class="row">
                        <div class="col-lg-5">
                          <p class="new-title">
                            Payment Term <span style="color: #EC1B23">*</span>
                          </p>
                        </div>
                        <div class="col-lg-2 text-center">
                          <input
                            style="text-align: center"
                            type="number"
                            min="0"
                            v-model="paymentterm"
                            :class="{ 'custom-input': true }"
                          />
                        </div>
                        <div class="col-lg-3 text-left">
                          <p class="new-title">Days</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6">
                      <div class="row">
                        <div class="col-lg-4">
                          <p class="new-title">
                            Validity <span style="color: #EC1B23">*</span>
                          </p>
                        </div>
                        <div class="col-lg-2">
                          <input
                            style="text-align: center"
                            type="number"
                            min="0"
                            v-model="validity"
                            :class="{ 'custom-input': true }"
                          />
                        </div>
                        <div class="col-lg-4 text-left">
                          <p class="new-title">Days</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- future -->
              <!-- <div class="row">
                <div class="col-lg">
                  <p class="new-title">Internal Remarks</p>
                  <input type="text" v-model="remark1" :class="{ 'custom-input': true }" />
                </div>
              </div> -->
              <div class="row" v-if="positionid == 1 || positionid == 2">
                <div class="col-lg">
                  <p class="new-title">Internal Remarks</p>
                  <input
                    type="text"
                    v-model="internalremark"
                    :class="{ 'custom-input': true }"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-lg">
                  <p class="new-title">Remarks</p>
                  <input
                    type="text"
                    v-model="remark1"
                    :class="{ 'custom-input': true }"
                  />
                </div>
              </div>
            </div>
            <div
              style="height: 750px; overflow: auto; overflow-x: hidden"
              v-if="(positionid == 1 || positionid == 2) && step != 2"
            >
              <div class="row">
                <div class="col-lg-4">
                  <p class="new-title">Subject Line</p>
                  <p class="subtitle">{{ subjectline }}</p>
                </div>
              </div>
              <br />
              <div class="row">
                <div class="col-lg">
                  <el-table
                    :data="quotations"
                    :header-cell-style="{
                      background: '#358DCC',
                      border: 'transparent',
                      'font-size': '14px',
                      'font-weight': '400',
                      color: '#FFFFFF',
                    }"
                    :cell-style="{ fontColor: '#707070' }"
                    :row-style="tableRowClassName"
                    style="color: #707070"
                  >
                    <el-table-column label="NO." width="50" align="center">
                      <div slot-scope="scope">
                        <p
                          style="color: #707070"
                          v-if="scope.row.description != 'GRAND TOTAL'"
                        >
                          {{ scope.$index + 1 }}
                        </p>
                      </div>
                    </el-table-column>

                    <el-table-column
                      :min-width="200"
                      align="center"
                      label="DESCRIPTION"
                      prop="description"
                    >
                      <div slot-scope="{ row }">
                        <div align="left">
                          <div class="row">
                            <div class="col-lg">
                              <p style="color: #A5A5A5">{{ row.description }}</p>

                              <p
                                style="color: #A5A5A5; word-break: break-word"
                                v-if="row.description != 'GRAND TOTAL'"
                              >
                                Waste Sub Type: {{ row.wastesubtype }}
                              </p>
                              <p
                                style="color: #A5A5A5; word-break: break-word"
                                v-if="row.description != 'GRAND TOTAL'"
                              >
                                Transportation rate
                              </p>
                              <br />
                            </div>
                          </div>
                        </div>
                      </div>
                    </el-table-column>

                    <el-table-column
                      :min-width="150"
                      align="center"
                      label="RATE"
                      prop="rate"
                    >
                      <div
                        slot-scope="{ row }"
                        v-if="row.description != 'GRAND TOTAL'"
                      >
                        <div class="row">
                          <div class="col-lg">RM {{ row.rate }}</div>
                        </div>
                        <div class="row">
                          <div class="col-lg">
                            RM {{ row.transportationrate }}
                          </div>
                        </div>
                      </div>
                    </el-table-column>

                    <el-table-column
                      :min-width="150"
                      align="center"
                      label="EST. AMOUNT"
                      prop="estamount"
                    >
                      <div slot-scope="{ row }">
                        {{ row.estamount }} {{ row.estunit }}
                      </div>
                    </el-table-column>

                    <el-table-column
                      :min-width="200"
                      align="center"
                      label="AMOUNT (RM)"
                      prop="amount"
                    >
                      <div slot-scope="{ row }">RM {{ row.amount }}</div>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12">
                  <div class="row">
                    <div class="col-lg">
                      <p class="new-title">Delivery Term</p>
                      <p class="subtitle">
                        {{ this.deliveryterm }} {{ this.deliverytermunit }}
                      </p>
                    </div>
                    <div class="col-lg">
                      <p class="new-title">Payment Term</p>
                      <p class="subtitle">{{ this.paymentterm }} Days</p>
                    </div>
                    <!-- <p class="sub-title">{{ this.paymentterm2 }}</p> -->
                    <div class="col-lg">
                      <p class="new-title">Validity</p>
                      <p class="subtitle">{{ this.validity }} Days</p>
                    </div>
                  </div>
                </div>
              </div>
              <!-- future
            <div class="col-lg-12">
              <div class="row">
                <div class="col-lg">
                  <p class="new-title">Internal Remarks</p>
                  <p class="sub-title">{{ this.remark1 }}</p>
                </div>
              </div>
            </div> -->
              <div class="row" v-if="roleid == 1">
                <div class="col-lg">
                  <p class="new-title">Internal Remarks</p>
                  <p class="subtitle">{{ internalremark }}</p>
                </div>
              </div>

              <div class="row">
                <div class="col-lg">
                  <p class="new-title">Remarks</p>
                  <p class="subtitle">{{ this.remark1 }}</p>
                </div>
              </div>
            </div>
            <div
              style="height: 750px; overflow: auto; overflow-x: hidden"
              v-if="positionid != 1 && positionid != 2"
            >
              <div class="row">
                <div class="col-lg-4">
                  <p class="new-title">Subject Line</p>
                  <p class="subtitle">{{ subjectline }}</p>
                </div>
              </div>
              <br />
              <div class="row">
                <div class="col-lg">
                  <el-table
                    :data="quotations"
                    :header-cell-style="{
                      background: '#358DCC',
                      border: 'transparent',
                      'font-size': '14px',
                      'font-weight': '400',
                      color: '#FFFFFF',
                    }"
                    :cell-style="{ fontColor: '#707070' }"
                    :row-style="tableRowClassName"
                    style="color: #707070"
                  >
                    <el-table-column label="NO." width="50" align="center">
                      <div slot-scope="scope">
                        <p
                          style="color: #707070"
                          v-if="scope.row.description != 'GRAND TOTAL'"
                        >
                          {{ scope.$index + 1 }}
                        </p>
                      </div>
                    </el-table-column>

                    <el-table-column
                      :min-width="200"
                      align="center"
                      label="DESCRIPTION"
                      prop="description"
                    >
                      <div slot-scope="{ row }">
                        <div align="left">
                          <div class="row">
                            <div class="col-lg">
                              <p style="color: #A5A5A5">{{ row.description }}</p>

                              <p
                                style="color: #A5A5A5; word-break: break-word"
                                v-if="row.description != 'GRAND TOTAL'"
                              >
                                Waste Sub Type: {{ row.wastesubtype }}
                              </p>
                              <p
                                style="color: #A5A5A5"
                                v-if="row.description != 'GRAND TOTAL'"
                              >
                                Transportation Rate:
                              </p>
                              <br />
                            </div>
                          </div>
                        </div>
                      </div>
                    </el-table-column>

                    <el-table-column
                      :min-width="150"
                      align="center"
                      label="RATE"
                      prop="rate"
                    >
                      <div
                        slot-scope="{ row }"
                        v-if="row.description != 'GRAND TOTAL'"
                      >
                        <div class="row">
                          <div class="col-lg">RM {{ row.rate }}</div>
                        </div>
                        <div class="row">
                          <div class="col-lg">
                            RM {{ row.transportationrate }}
                          </div>
                        </div>
                      </div>
                    </el-table-column>

                    <el-table-column
                      :min-width="150"
                      align="center"
                      label="EST. AMOUNT"
                      prop="estamount"
                    >
                      <div slot-scope="{ row }">
                        {{ row.estamount }} {{ row.estunit }}
                      </div>
                    </el-table-column>

                    <el-table-column
                      :min-width="200"
                      align="center"
                      label="AMOUNT (RM)"
                      prop="amount"
                    >
                      <div slot-scope="{ row }">RM {{ row.amount }}</div>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12">
                  <div class="row">
                    <div class="col-lg">
                      <p class="new-title">Delivery Term</p>
                      <p class="subtitle">
                        {{ this.deliveryterm }} {{ this.deliverytermunit }}
                      </p>
                    </div>
                    <div class="col-lg">
                      <p class="new-title">Payment Term</p>
                      <p class="subtitle">{{ this.paymentterm }} Days</p>
                    </div>
                    <!-- <p class="sub-title">{{ this.paymentterm2 }}</p> -->
                    <div class="col-lg">
                      <p class="new-title">Validity</p>
                      <p class="subtitle">{{ this.validity }} Days</p>
                    </div>
                  </div>
                </div>
              </div>
              <!-- future
            <div class="col-lg-12">
              <div class="row">
                <div class="col-lg">
                  <p class="new-title">Internal Remarks</p>
                  <p class="sub-title">{{ this.remark1 }}</p>
                </div>
              </div>
            </div> -->
              <div class="row" v-if="roleid == 1">
                <div class="col-lg">
                  <p class="new-title">Internal Remarks</p>
                  <p class="subtitle">{{ internalremark }}</p>
                </div>
              </div>

              <div class="row">
                <div class="col-lg">
                  <p class="new-title">Remarks</p>
                  <p class="subtitle">{{ this.remark1 }}</p>
                </div>
              </div>
            </div>
          </card>
        </div>
        <div v-if="generate == true" class="col-lg-4 d-flex">
          <card class="card-eprf">
            <p style="color: #358CCB; font-size: 24px; font-weight: 300">
              QUOTATION
            </p>
            <p v-if="positionid == 1" class="newtitle">Edit Quotation</p>

            <base-button
              v-if="positionid == 1"
              type="primary"
              wide
              @click="generate = false"
              class="btn-next"
            >
              Edit
            </base-button>

            <br />
            <br />
            <br />

            <!-- <div class="fileinput" v-if="positionid == 1">
              <label for="file-upload" type="primary" class="btn" style="
                  font-size: 13px;
                  color: #ffffff;
                  text-transform: capitalize;
                ">
                Choose File
              </label>
              <div class="d-flex justify-content-center spinner" v-if="this.uploadload == true">
                <circle-8></circle-8>
              </div>

              <input accept="application/pdf" id="file-upload" ref="file" type="file" name="..." class="valid"
                :multiple="true" aria-invalid="false" style="display: none" v-on:change="onFileChange" />
            </div> -->
            <!-- scrollable green flex-grow-1 flex-shrink-0 overflow-auto -->
            <!-- <div class="">
              <div v-for="(file, index) in allfilename" :key="index" class="row">
                <div class="col-lg-8">
                  <p style="padding-left: 15px; color: #A5A5A5" id="file-name">
                    {{ file.filename }}
                  </p>
                </div>
                <div class="col-lg-4" v-if="positionid == 1">
                  <base-button class="btn-sm btn-cancel" style="font-size: 12px" @click="removeFile(file.fileid)">
                    Remove
                  </base-button>
                </div>
              </div>
            </div> -->
            <!-- margin-top: 50px -->
            <p style="" class="newtitle">View Your Generated Quotation</p>
            <base-button type="primary" v-on:click="createPDF()"
              >View</base-button
            >
          </card>
        </div>
      </div>
      <div class="row">
        <div class="col-lg text-right">
          <base-button
            v-if="generate == false"
            wide
            type="danger"
            @click="back()"
            class="btn-previous"
          >
            BACK
          </base-button>

          <base-button
            v-if="
              (positionid == 1 || positionid == 2) &&
              generate == false &&
              step == 2
            "
            type="primary"
            wide
            @click="generateQuotation()"
            class="btn-next"
          >
            GENERATE
          </base-button>

          <base-button
            v-if="
              (positionid == 1 || positionid == 2) &&
              generate == false &&
              step != 2
            "
            type="primary"
            wide
            @click="generate = true"
            class="btn-next"
          >
            NEXT
          </base-button>

          <base-button
            v-if="
              (positionid == 1 || positionid == 2) &&
              generate == true &&
              step != 2
            "
            wide
            type="danger"
            @click="generate = false"
            class="btn-previous"
          >
            BACK
          </base-button>

          <base-button
            v-if="
              (positionid == 1 || positionid == 2) &&
              generate == true &&
              step != 2
            "
            type="primary"
            wide
            @click="nextTab"
            class="btn-next"
          >
            NEXT
          </base-button>

          <base-button
            v-if="positionid == 4 && generate == false && step == 2"
            type="cancel"
            wide
            class="btn-next"
            @click="modals.disputereason = true"
          >
            DISPUTE
          </base-button>

          <base-button
            v-if="positionid == 4 && generate == false && step == 2"
            type="primary"
            wide
            class="btn-next"
            @click="approve()"
          >
            APPROVE
          </base-button>
          <base-button
            v-if="positionid == 4 && generate == false && step == 2"
            type="primary"
            wide
            class="btn-next"
            @click="approveConcession()"
          >
            APPROVE CONCESSION
          </base-button>
          <base-button
            v-if="positionid == 4 && generate == false && step != 2"
            type="primary"
            wide
            @click="nextTab"
            class="btn-next"
          >
            NEXT
          </base-button>
        </div>
      </div>
      <div class="row" v-if="generate == false">
        <div class="col-lg text-right">
          <base-button
            class="btn-link"
            style="color: #052d72; cursor: pointer; text-decoration: underline"
            @click="saveDraft()"
          >
            Save Draft
          </base-button>
          <!-- <p
            style="color: #052d72; cursor: pointer; text-decoration: underline"
            @click="saveDraft()"
          >
            Save Draft
          </p> -->
        </div>
      </div>
      <modal :show.sync="modals.disputereason" class="modal-eprf" centered>
        <b-card
          class="card text-center"
          style="background-color: #f5f6fa; box-shadow: none"
          border-variant="primary"
          header="REASON FOR DISPUTE"
          header-bg-variant="primary"
          header-text-variant="white"
        >
          <template #header>
            <div class="row">
              <div class="col-lg text-left">
                <h4 class="mb-0">REASON FOR DISPUTE</h4>
              </div>
              <div class="col-lg-3 text-right" style="padding-bottom: 10px">
                <base-button class="btn-icon btn-cancel btn-round btn-sm">
                  <i
                    style="
                      transform: translate(-50%, -50%);
                      color: white;
                      font-weight: 900;
                      font-size: 12px;
                    "
                    class="tim-icons icon-simple-remove"
                    @click="modals.disputereason = false"
                  ></i>
                </base-button>
              </div>
            </div>
          </template>

          <div class="row">
            <div class="col-lg-12">
              <textarea
                type="textarea"
                placeholder="Reason for rejection..."
                v-model="reason"
                :class="{ textarea: true }"
              ></textarea>
            </div>
          </div>

          <div class="row">
            <div class="col-lg text-right">
              <base-button type="primary" v-on:click="dispute()"
                >Submit</base-button
              >
            </div>
          </div>
        </b-card>
      </modal>
      <modal :show.sync="modals.generate" class="modal-eprf" centered>
        <div class="row">
          <div class="col-lg text-center">
            <img src="@/assets/img/tick.png" width="300" />
            <br />
            <br />
            <br />
            <h1>QUOTATION SUBMITTED</h1>
            <p>
              Admin Management has been notified to review and approve the
              quotation
            </p>
          </div>
        </div>
      </modal>
      <modal :show.sync="modals.approve" class="modal-eprf" centered>
        <div class="row">
          <div class="col-lg text-center">
            <img src="@/assets/img/tick.png" width="300" />
            <br />
            <br />
            <br />
            <h1>QUOTATION SUBMITTED</h1>
            <p>
              Customer has been notified to review and approve the quotation
            </p>
          </div>
        </div>
      </modal>
      <modal :show.sync="modals.reject" class="modal-eprf" centered>
        <div class="row">
          <div class="col-lg text-center">
            <img src="@/assets/img/tick.png" width="300" />
            <br />
            <br />
            <br />
            <h1>DISPUTE QUOTATION SUBMITTED</h1>
            <p>Customer has been notified the dispution of the quotation</p>
          </div>
        </div>
      </modal>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn, Option, Select, DatePicker } from "element-ui";
import swal from "sweetalert2";
import { ImageUpload, Modal } from "src/components";
import { Circle8 } from "vue-loading-spinner";
import moment from "moment";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import "jspdf-autotable";
import { BCard } from "bootstrap-vue";

export default {
  props: ["parentData"],
  components: {
    BCard,
    ImageUpload,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [DatePicker.name]: DatePicker,
    Circle8,
    Modal,
    html2canvas,
  },
  props: ["test1"],
  data() {
    return {
      step: 0,
      internalremark: "",
      ddate: "2024-06-21T08:09:16.236226Z",
      vvalidity: "400 days",
      durationString: "",
      duration: "",
      marketingchannel: "",
      cancelledref: "",
      cancelledrefs: [],
      accessid: 0,
      reason: "",
      positionid: "",
      roleid: "",
      landvesselflag: "LAND",
      jobno: "",
      arrivalETA: "18 Nov 2022",
      servicelocation: "",
      servicelocationcollection: "",
      departureETD: "15 Nov 2022",
      previousPort: "None",
      nextPort: "None",
      lastPortAndDate: "None",
      lastDate: "",

      companyName: "Ombak Biru Holdings",
      companyAddress: "Coplace 2, Switzeeerrrrrss",
      phoneNoFaxNo: "08-98989989",
      picFullName: "Wahab bin Wahab",
      picPhoneNoFaxNo: "012-3569488",
      picEmail: "wahab@sendirianberhad.com",
      shipName: "Tiger Wave",
      imoNo: "8804275",
      shipType: "Ikan bilis tanker",
      grossTonnage: "220000",
      deadweightTonnage: "10000",
      owneroperatorname: "Abu bin Seman",
      callSign: "Bilis dot com",
      flagState: "Malaysia",
      sustainableCertificates: "1 - ISO 14001.pdf",
      shipdoc: [],

      subjectline: "",
      quotations: [
        // {
        //   id: "1",
        //   description: "Annex l - Oily Bilge Waste",
        //   rate: "2.0",
        //   estamount: "10",
        //   amount: "20",
        // },
        // {
        //   id: "1",
        //   description: "Annex l - Oily Bilge Waste",
        //   rate: "2.0",
        //   estamount: "10",
        //   amount: "20",
        // },
        // {
        //   id: "1",
        //   description: "Annex l - Oily Bilge Waste",
        //   rate: "2.0",
        //   estamount: "10",
        //   amount: "20",
        // },
        // {
        //   id: "1",
        //   description: "Annex l - Oily Bilge Waste",
        //   rate: "2.0",
        //   estamount: "10",
        //   amount: "20",
        // },
        // {
        //   id: "1",
        //   description: "GRAND TOTAL",
        //   rate: "",
        //   estamount: "",
        //   amount: "80",
        // },
      ],
      deliveryterm: "",
      deliverytermunit: "",
      paymentterm1: "",
      paymentterm: "",
      validity: "",
      remark1: "",

      modals: {
        generate: false,
        approve: false,
        reject: false,
        disputereason: false,
      },
      generate: false,
      selectedFileName: "",
      allfilename: [],
      docs: "",
      document: 0,

      documentID: [],

      uploadload: false,

      img: null,
      imgdescription: "",
      image: "",
      imagebase64: "",
      images: {
        regular: null,
      },

      description: "None",

      admintelno: "+60197897654",

      selects: {
        date: "",

        rate: "",
        rates: [
          { value: "m3", label: "M³" },
          { value: "kg", label: "Kg" },
          { value: "unit", label: "Unit" },
        ],

        adminpic: "",
        adminpics: [
          { value: "01", label: "Amirah binti Azman" },
          { value: "02", label: "Yahya Abd Rahman" },
          { value: "03", label: "Haziq Haikal bin Ayub" },
        ],
        day: "Day",
        days: [
          {
            label: "Days",
            value: "Days",
          },
          {
            label: "Working Days",
            value: "Working Days",
          },
        ],
      },
      pdftable: [],
      //pdf
      companynamepdf: "",
      refno: "",
      date: "",
      currentpage: "",
      totalpage: "",
      companyaddresspdf: "",
      companyphonenopdf: "",
      companyemailpdf: "",
      attention: "",
      subject: "",

      deliverypdf: "",
      paymentpdf: "",
      validitypdf: "",
      remarkspdf: "",

      pic1pdf: "",
      pic1nopdf: "",
      pic1emailpdf: "",
      pic2pdf: "",
      pic2nopdf: "",
      total: 0,
    };
  },
  created() {
    this.jobno = this.$route.params.jobnum.split("_")[0];
    this.getDetail();
    this.positionid = parseInt(
      JSON.parse(atob(sessionStorage.getItem("token").split(".")[1]))
        .position_id
    );
    this.roleid = parseInt(
      JSON.parse(atob(sessionStorage.getItem("token").split(".")[1])).role_id
    );

    console.log("position ID: ", this.positionid);

    window.addEventListener("beforeunload", function (event) {
      this.saveDraft();
      event.preventDefault();
    });
  },
  mounted() {
    this.getCancelRef(this.jobno);
  },
  computed: {},
  watch: {
    quotations: {
      handler(newVal, oldVal) {
        let grandTotal = 0.0;
        const formatter = new Intl.NumberFormat("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
        newVal.map((item) => {
          if (item.description === "GRAND TOTAL") {
            
            item.amount = formatter.format(grandTotal);
          } else {
            // console.log(Number(item.rate))
            // console.log()
            
            if(item.rate == ""){
              item.rate = 0
            }

            if(item.transportationrate == ""){
              item.transportationrate = 0
            }

            item.amount = formatter.format(
              parseInt(item.estamount) * parseInt(item.rate) +
                parseInt(item.transportationrate)
            );

            
            grandTotal += 
              parseInt(item.estamount) * parseInt(item.rate) +
              parseInt(item.transportationrate)
            
            
          }
        });
      },
      deep: true,
    },
    // quotations: (() => map.value, (currentValue) => {
    //   console.log("test")
    // }),
    // step(){
    //   let parameter = {
    //     step: (this.step - 1).toString(),
    //     direction: "depan",
    //     data: [],
    //   };
    //   this.$emit("my-event", parameter);
    // },
    generate() {
      console.log(this.generate);
    },
  },
  methods: {
    convertDays(totalDays) {
      const daysInYear = 365;
      const daysInWeek = 7;

      const years = Math.floor(totalDays / daysInYear);
      const weeks = Math.floor((totalDays % daysInYear) / daysInWeek);
      const days = totalDays % daysInWeek;

      let result = "";
      if (years > 0) result += `${years} years, `;
      if (weeks > 0) result += `${weeks} weeks, `;
      result += `${days} days`;

      // Remove any trailing comma and space
      return result.replace(/,\s*$/, "");
    },

    calculateDuration() {
      const parsedDate = moment(this.ddate, moment.ISO_8601, true);
      const endDate = parsedDate.clone().add(moment.duration(this.validity));

      const years = endDate.diff(parsedDate, "years");
      parsedDate.add(years, "years");

      const months = endDate.diff(parsedDate, "months");
      parsedDate.add(months, "months");

      const days = endDate.diff(parsedDate, "days");

      let readableString = "";

      if (years > 0) {
        readableString += `${years} year${years > 1 ? "s" : ""}`;
      }

      if (months > 0) {
        if (readableString.length > 0) readableString += " ";
        readableString += `${months} month${months > 1 ? "s" : ""}`;
      }

      if (days > 0) {
        if (readableString.length > 0) readableString += " ";
        readableString += `${days} day${days > 1 ? "s" : ""}`;
      }

      readableString += ` (${endDate.format("YYYY-MM-DD")} - ${moment(
        this.date
      ).format("YYYY-MM-DD")})`;

      this.durationString = readableString;

      console.log(this.durationString);
    },
    sendCancelledRef() {
      let obj = {
        reference_number: this.cancelledref,
      };

      this.$http
        .post(":10001/api/v1/incoming/" + this.jobno + "/accept", obj)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.message = response;
            this.modals.successModal = true;
          }
        });
    },
    getCancelRef(refno) {
      console.log(refno);

      this.$http
        .get(":10001/api/v1/incoming/" + refno + "/cancelled-ref")
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);

            for (var i = 0; i < response.reference_number.length; i++) {
              let obj = {
                value: response.reference_number[i],
                label: response.reference_number[i],
              };
              this.cancelledrefs.push(obj);
            }
          }
        });
    },
    dispute() {
      if (this.reason != "") {
        let obj = {
          quotation_dispute_reason: this.reason,
          // remarks: this.reason,
        };

        this.$http
          .put(
            ":10001/api/v1/incoming/" + this.jobno + "/quotation/reject",
            obj
          )
          .then((res) => {
            if (!res.error) {
              let response = res.message;

              console.log(response);

              this.modals.reject = true;

              setTimeout(() => {
                this.modals.reject = false;
                console.log("what");
                this.$router.push("/Incoming");
              }, 1000);
            }
          });
      } else {
        // reason is compulsory
        swal({
          title: `Info!`,
          text: "Please fill in the reason",
          buttonsStyling: false,
          confirmButtonClass: "btn btn-primary btn-fill",
          type: "warning",
        });
      }
    },
    approveConcession() {
      swal({
        title: "Approve concession?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        console.log(result);
        if (result.value == true) {
          this.$http
            .put(
              ":10001/api/v1/incoming/" +
                this.jobno +
                "/quotation/concession/approve"
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                swal({
                  title: `Success!`,
                  text: "Approve success.",
                  buttonsStyling: false,
                  confirmButtonClass: "btn btn-primary btn-fill",
                  type: "success",
                }).then((result) => {
                  console.log(result);
                  if (result.value) {
                    //pastu kena ke mana
                    this.$router.push("/Incoming");
                  }
                });
              }
            })
            .catch((err) => {
              swal({
                title: `Error!`,
                text: "Approve failed.",
                buttonsStyling: false,
                confirmButtonClass: "btn btn-cancel btn-fill",
                type: "error",
              });
            });
        }
      });
    },
    approve() {
      this.$http
        .put(":10001/api/v1/incoming/" + this.jobno + "/quotation/approve")
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.modals.approve = true;

            setTimeout(() => {
              this.modals.approve = false;
              this.$router.push("/Incoming");
            }, 1000);
          }
        });
    },
    next() {
      this.generate = true;
      this.positionid = parseInt(
        JSON.parse(atob(sessionStorage.getItem("token").split(".")[1]))
          .position_id
      );
    },
    back() {
      this.positionid = parseInt(
        JSON.parse(atob(sessionStorage.getItem("token").split(".")[1]))
          .position_id
      );
      this.generate = false;
      this.prevTab();
    },
    async createPDF() {
      await this.getPDF();
      this.duration = this.convertDays(this.validity);
      let doc = jsPDF({
        orientation: "potrait",
      });

      const logo = new Image();
      logo.src = require("@/assets/img/afesnew.png");
      logo.onload = () => {
        this.options = Object.assign({}, this.options, {
          logo: {
            logo,
          },
        });
      };

      const sign = new Image();
      sign.src = require("@/assets/img/autograph.png");
      sign.onload = () => {
        this.options = Object.assign({}, this.options, {
          sign: {
            sign,
          },
        });
      };

      const data = this.pdftable;

      const columns = [
        "No.",
        "\t\t\t\t\t\t\tDescription",
        "Unit Price (RM)",
        "Quantity",
      ];

      const rows = data.map((obj) => [
        obj.no,
        obj.desc,
        obj.rate,
        obj.estamt,
        obj.amt,
      ]);

      doc.addImage(
        logo,
        "PNG",
        doc.internal.pageSize.getWidth() - 75,
        5,
        50,
        18.75
      );

      doc.setFontSize(21);
      doc.setFontStyle("bold");
      doc.text("QUOTATION", 15, 25);
      doc.setFontSize(11);

      doc.setLineWidth(0.3);
      doc.line(10, 40, doc.internal.pageSize.getWidth() - 10, 40);

      doc.setFontStyle("bold");

      doc.text(this.companynamepdf, 15, 55);

      doc.setFontStyle("normal");

      var companyAddress = this.companyaddresspdf;
      var maxCharactersPerLine = 25;

      function splitTextIntoLines(text, maxLength) {
        var lines = [];
        while (text.length > maxLength) {
          var line = text.substring(0, maxLength);
          var lastSpace = line.lastIndexOf(" ");
          if (lastSpace !== -1) {
            lines.push(line.substring(0, lastSpace));
            text = text.substring(lastSpace + 1);
          } else {
            lines.push(line);
            text = text.substring(maxLength);
          }
        }
        lines.push(text);
        return lines;
      }

      var addressLines = splitTextIntoLines(
        companyAddress,
        maxCharactersPerLine
      );

      for (var i = 0; i < addressLines.length; i++) {
        var yPos = 60 + i * 5;
        doc.text(addressLines[i], 15, yPos);
      }

      doc.setFontStyle("bold");
      doc.text("Ref No.", 130, 55);
      doc.text("Date", 130, 60);
      doc.setFontStyle("normal");

      doc.text(":", 150, 55);
      doc.text(":", 150, 60);

      doc.text(this.jobno, 152, 55);
      doc.text(moment().format("DD-MM-YYYY"), 152, 60);

      doc.text("Tel No. : " + this.pic1nopdf, 15, 80);

      // doc.text("Email : -", 130, 80);
      doc.text("Email : " + this.pic1emailpdf, 130, 80);
      // doc.text(this.companyemailpdf, 85, 80);

      doc.setFontStyle("bold");

      doc.text("Attention", 15, 90);
      doc.text("Subject", 15, 95);

      doc.text(":", 35, 90);
      doc.text(":", 35, 95);

      doc.text(this.pic1pdf, 40, 90);
      doc.text(this.subject, 40, 95);

      doc.setFontStyle("normal");

      doc.text("Dear Sir/Madam,", 15, 105);
      doc.text(
        "We appreciate this opportunity to offer you our quotation as follows:",
        15,
        115
      );

      const table = doc.autoTable({
        head: [columns],
        columnStyles: {
          0: {
            halign: "center",
            cellWidth: 10,
          },
          1: {
            // columnWidth: 100,
          },
          2: {
            halign: "center",
            cellWidth: 30,
          },
          3: {
            halign: "center",
            cellWidth: 20,
          },
        },
        styles: {
          lineWidth: 0.1, // Set the border line width
          lineColor: [0, 0, 0], // Set the border color
        },
        theme: "plain",
        body: rows,
        startY: 120,
      });

      // let deliveryTermsTextPositionY = table.autoTable.previous.finalY + 10;

      // if (deliveryTermsTextPositionY > doc.internal.pageSize.getHeight() - 20) {
      //   doc.addPage();
      //   deliveryTermsTextPositionY = 20;
      // }

      const tableHeight = table.autoTable.previous.finalY;

      doc.text("Terms & Conditions", 15, tableHeight + 10);
      doc.text("Terms of Delivery", 15, tableHeight + 15);
      doc.text("Terms of Payment", 15, tableHeight + 20);
      doc.text("Validity", 15, tableHeight + 25);
      doc.text("Remarks", 15, tableHeight + 30);

      // doc.text(":", 55, tableHeight + 10);
      doc.text(":", 55, tableHeight + 15);
      doc.text(":", 55, tableHeight + 20);
      doc.text(":", 55, tableHeight + 25);
      doc.text(": ", 55, tableHeight + 30);

      doc.text(
        "a) Payment for completed services to be paid and made payable to",
        60,
        tableHeight + 30
      );
      doc.setFontStyle("bold");

      doc.text(
        "ALAM FLORA ENVIRONMENTAL SOLUTIONS SDN BHD.",
        60,
        tableHeight + 35
      );
      doc.setFontStyle("normal");
      doc.text(
        "b) All price(s) quoted is inclusive of Sales and Services Tax (SST), customs",
        60,
        tableHeight + 40
      );
      doc.text(
        "clerance or taxes and customs agent fees (if any).",
        60,
        tableHeight + 45
      );
      doc.text(
        "c) The invoiced quantity will be in accordance to the actual quantity",
        60,
        tableHeight + 50
      );
      doc.text(
        "collected and recorded in weigh bridge weight chit.",
        60,
        tableHeight + 55
      );
      // doc.text(
      //   "d)" + this.remark1,
      //   60,
      //   tableHeight + 60
      // );

      const ddate = "2024-06-21T08:09:16.236226Z";
      const validity = this.validity + " Days";
      console.log(validity);
      // Parse the date using Moment.js
      const parsedDate = moment(ddate);

      // Add the validity period to the parsed date
      const endDate = parsedDate.clone().add(moment.duration(validity));

      // Calculate the difference in years, months, and days
      const diff = moment.duration(endDate.diff(parsedDate));
      const years = diff.years();
      const months = diff.months();
      const days = diff.days();

      // Format the result into a human-readable string
      let readableString = "";

      if (years > 0) {
        readableString += `${years} year${years > 1 ? "s" : ""}`;
      }

      if (months > 0) {
        if (readableString.length > 0) readableString += " ";
        readableString += `${months} month${months > 1 ? "s" : ""}`;
      }

      if (days > 0) {
        if (readableString.length > 0) readableString += " ";
        readableString += `${days} day${days > 1 ? "s" : ""}`;
      }

      readableString += ` (${parsedDate.format(
        "YYYY-MM-DD"
      )} - ${endDate.format("YYYY-MM-DD")})`;

      console.log(readableString);

      doc.text(
        this.deliveryterm + " " + this.deliverytermunit,
        60,
        tableHeight + 15
      );
      doc.text(this.paymentterm + " Days", 60, tableHeight + 20);
      doc.text(this.duration + " " + this.durationString, 60, tableHeight + 25); //kena kira kat sini
      var text = this.remark1;
      var x = 60;
      var y = tableHeight + 60;

      var lines = doc.splitTextToSize(
        text,
        doc.internal.pageSize.width - x * 1.3
      );

      if (this.remark1 != "" && this.remark1 != null) {
        doc.text("d) " + lines[0], x, y);
      }
      for (var i = 1; i < lines.length; i++) {
        if (y + 50 > doc.internal.pageSize.getHeight() - 20) {
          doc.addPage();
          y = 25;
        }
        doc.text(lines[i], x, y + 5);
        y += 5;
      }

      // let nextContentYPosition = table.autoTable.previous.finalY + y;

      // if (nextContentYPosition > doc.internal.pageSize.getHeight() - 20) {
      //   doc.addPage();
      //   nextContentYPosition = 20;
      // }

      var finalYOfText = y;

      doc.text(
        "If you agree with the quotation, please sign in below and send/email it to us as attached as soon as",
        15,
        finalYOfText + 10
      );

      doc.text("possible for further arrangement.", 15, finalYOfText + 15);
      doc.text(
        "Should you need any clarification, please contact " +
          this.pic1pdf +
          " at " +
          this.pic1nopdf,
        15,
        finalYOfText + 20
      );
      // doc.text(this.picname, 15, finalYOfText + 35);

      // doc.text("at", 95, finalYOfText + 35);

      // doc.text(this.picphoneno, 105, finalYOfText + 35);
      doc.setFontStyle("bold");

      doc.text(
        "for ALAM FLORA ENVIRONMENTAL SOLUTIONS SDN BHD",
        15,
        finalYOfText + 30
      );
      doc.setFontStyle("normal");

      doc.text(
        "Previously known as DRB-HICOM ENVIRONMENTAL SERVICES SDN BHD",
        15,
        finalYOfText + 35
      );

      doc.setFontStyle("bold");

      doc.addImage(
        sign,
        "PNG",
        doc.internal.pageSize.getWidth() - 195,
        finalYOfText + 40,
        30,
        15
      );

      doc.text("NAZIRA MAHAYUDDIN", 15, finalYOfText + 60);

      doc.setFontStyle("normal");
      doc.text("Senior Manager,", 15, finalYOfText + 65);
      doc.text("Marine Waste Management,", 15, finalYOfText + 70);
      doc.text(
        "Environmental Technology & Solutions Department",
        15,
        finalYOfText + 75
      );

      //acknowledgement start here
      doc.addPage();
      doc.text("TO:", 15, 25);
      doc.setFontStyle("bold");
      doc.text("ALAM FLORA ENVIRONMENTAL SOLUTIONS SDN BHD", 15, 30);
      doc.text("MARINE WASTE MANAGEMENT, PORT RECEPTION FACILITIES", 15, 35);

      doc.setFontStyle("normal");
      doc.text("Attention : " + this.pic1pdf, 15, 45);
      // doc.text("Email : " + this.pic1nopdf, 100, 45);
      doc.text("Email : " + this.pic1emailpdf, 100, 45);

      doc.setFontStyle("bold");
      doc.text("ACKNOWLEDGEMENT / ACCEPTANCE OF OFFER", 60, 55);

      doc.setFontStyle("normal");
      doc.text(
        "I, .................................................................................................. as ................................................................",
        15,
        65
      );

      doc.setFontStyle("italic");

      doc.text("(Name)", 55, 70);
      doc.text("(Designation)", 145, 70);

      doc.setFontStyle("normal");

      doc.text(
        "Agreed to the quotation stated in the above mentioned letter ref no. " +
          this.jobno,
        15,
        80
      );
      doc.text(
        "dated " +
          moment().format("DD MMMM YYYY") +
          " and all terms and condition as mentioned.",
        15,
        85
      );

      doc.text("Thank you.", 15, 95);

      doc.text("Company Name", 15, 105);
      doc.text(
        ": ...............................................................................................................................",
        60,
        105
      );

      doc.text("Company Address", 15, 115);
      doc.text(
        ": ...............................................................................................................................",
        60,
        115
      );
      doc.text(
        ": ...............................................................................................................................",
        60,
        120
      );
      doc.text(
        ": ...............................................................................................................................",
        60,
        125
      );

      doc.text("Contact Person", 15, 135);
      doc.text(
        ": ...............................................................................................................................",
        60,
        135
      );

      doc.text("Designation", 15, 145);
      doc.text(
        ": ...............................................................................................................................",
        60,
        145
      );

      doc.text("Tel. No.", 15, 155);
      doc.text(
        ": ...............................................................................................................................",
        60,
        155
      );

      doc.text("Mobile No.", 15, 165);
      doc.text(
        ": ...............................................................................................................................",
        60,
        165
      );
      doc.text("Email Address", 15, 185);
      doc.text(
        ": ...............................................................................................................................",
        60,
        185
      );

      doc.text("Service to commence", 15, 195);
      doc.text(
        ": ...............................................................................................................................",
        60,
        195
      );

      const xx = 70;
      const xxx = 130;

      const yy = 199;
      const yyy = 209;

      const width = 8;
      const height = 8;

      // Draw the box
      doc.rect(xx, yy, width, height);

      doc.rect(xxx, yy, width, height);

      doc.rect(xx, yyy, width, height);

      doc.rect(xxx, yyy, width, height);

      doc.text("Contract Preferred", 15, 205);
      doc.text(":", 60, 205);
      doc.text("One off job", 80, 205);
      doc.text("*Two (2) years", 140, 205);

      doc.text("*One (1) year", 80, 215);
      doc.text("*Others, please specify", 140, 215);

      doc.setFontStyle("italic");
      doc.text(
        "I/We declare that the data provided is correct and accordingly. I/We also declare that all",
        15,
        225
      );
      doc.text(
        "individuals who are subject of any personal data provided therein have consented to my/our",
        15,
        230
      );
      doc.text(
        'disclosure of the personal data to Alam Flora Environmental Solutions Sdn Bhd ("AFES")',
        15,
        235
      );
      doc.text(
        "(Previously known as DRB-HICOM Environmental Services Sdn Bhd (“DHES”)) and the use",
        15,
        240
      );
      doc.text(
        "by AFES of the personal data in accordance with the policy on personal data attached herein.",
        15,
        245
      );

      doc.text(
        ".......................................................",
        15,
        265
      );
      doc.text("(Signature & Company's Stamp)", 16, 270);

      doc.text(".................................................", 120, 265);
      doc.text("(Date)", 140, 270);

      // doc.text("Created by " + this.pic1pdf, 15, finalYOfText + 80);
      if (this.jobno.startsWith("V")) {
        doc.save("ANF Quotation.pdf");
      } else if (this.jobno.startsWith("L")) {
        doc.save("WCO Quotation.pdf");
      } else {
        doc.save("Quotation.pdf");
      }

      console.log("pdf createdd");
    },
    async getPDF() {
      this.pdftable = [];

      await this.$http
        .get(":10001/api/v1/incoming/" + this.jobno + "/quotation/generate")
        .then((res) => {
          if (!res.error) {
            let response = res.message;

            console.log("hiuu", response);

            console.log("wowow", this.quotations);

            this.companynamepdf = response.company_name;
            this.refno = response.reference_number;
            this.date = moment(response.quotation_issued_at).format(
              "DD-MM-YYYY"
            );

            this.companyaddresspdf = response.company_address;
            this.companyphonenopdf = response.customer_phone_number;
            this.companyemailpdf = response.customer_email;
            this.attention = response.customer_name;
            this.subject = response.subject_line;

            this.deliverypdf = response.delivery_term;
            this.paymentpdf = response.payment_term;
            this.validitypdf = response.validy;
            this.remarkspdf = response.remarks;

            this.pic1pdf = response.afes_pic_name;
            this.pic1nopdf = response.afes_pic_phone_number;
            this.pic1emailpdf = response.afes_pic_email;
            this.pic2pdf = "";
            this.pic2nopdf = "";

            let ratee;
            let estamtt;
            let amt;
            let amountt = 0;

            let formatter = new Intl.NumberFormat("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            });

            for (let i = 0; i < this.quotations.length - 1; i++) {
              console.log(this.quotations[i].estunit.toString());
            }

            for (var i = 0; i < response.waste_detail.length; i++) {
              ratee = response.waste_detail[i].rate.toFixed(2);
              estamtt = response.waste_detail[i].estimtEated_quantity;
              amt = ratee * estamtt;
              let obj = {
                no: i + 1,
                desc:
                  response.waste_detail[i].waste_type_name +
                  "\n" +
                  response.waste_detail[i].waste_sub_type_name +
                  "\n" +
                  "Transportation rate: RM" +
                  formatter.format(response.waste_detail[i].transport_rate),
                rate: formatter.format(ratee),
                estamt:
                  formatter.format(
                    response.waste_detail[i].estimated_quantity
                  ) +
                  // + " MT",
                  " " +
                  response.waste_detail[i].estimated_quantity_unit,
                // + this.quotations[i].estunit.toString(),
                amt: formatter.format(amt),
              };
              amountt += amt;
              this.pdftable.push(obj);
            }
          }
        });
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },

    rateChange(index) {
      console.log("hewoo");
      let formatter = new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

      // this.quotations[this.quotations.length - 1].amount = 0;

      // this.quotations[index].amount =
      //   this.quotations[index].rate *
      //   parseInt(this.quotations[index].estamount);

      // this.quotations[index].amount = this.quotations[index].amount.toFixed(2);
      // for (var i = 0; i < this.quotations.length - 1; i++) {
      //   this.quotations[this.quotations.length - 1].amount +=
      //     this.quotations[i].rate * parseInt(this.quotations[i].estamount);

      //   this.quotations[this.quotations.length - 1].amount += parseFloat(
      //     this.quotations[i].transportationrate
      //   );
      // }

      this.quotations[this.quotations.length - 1].amount = formatter.format(
        this.quotations[this.quotations.length - 1].amount
      );
    },

    getDetail() {
      this.total = 0;
      this.allfilename = [];
      this.quotations = [];
      this.shipdoc = [];

      this.$http.get(":10001/api/v1/incoming/" + this.jobno).then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);

          this.landvesselflag = response.company.company_type.toUpperCase();

          if (this.landvesselflag == "VESSEL") {
            this.marketingchannel =
              response.marketing_channel == null
                ? "N/A"
                : response.marketing_channel.name;
            if (this.positionid == 1 || this.positionid == 2) {
              this.cancelledref = response.prev_cancel_reference_no;
            } else {
              this.cancelledref =
                response.prev_cancel_reference_no == ""
                  ? "N/A"
                  : response.prev_cancel_reference_no;
            }
          } else {
            if (this.positionid == 1 || this.positionid == 2) {
              this.cancelledref = response.cancel_reference_no;
            } else {
              this.cancelledref =
                response.cancel_reference_no == ""
                  ? "N/A"
                  : response.cancel_reference_no;
            }
          }

          // this.step = response.step;

          if (typeof response.step == "string") {
            this.step = Number(response.step);
          } else if (typeof response.step == "number") {
            this.step = response.step;
          } else {
            this.step = response.step;
          }

          console.log("step", this.step);

          this.arrivalETA = moment(response.arrival_eta).format("DD MMM YYYY");

          this.servicelocation = response.service_location_name;
          this.servicelocationcollection =
            response.service_location_collection_name;

          this.departureETD = moment(response.departure_eta).format(
            "DD MMM YYYY"
          );
          this.previousPort =
            response.previous_port == "" ? "None" : response.previous_port;
          this.nextPort =
            response.next_port == "" ? "None" : response.next_port;
          this.lastPortAndDate =
            response.last_port == "" ? "None" : response.last_port;

          this.lastDate =
            response.last_port_date == ""
              ? "N/A"
              : moment(response.last_port_date).format("DD MMM YYYY");

          this.companyName = response.company.company_name;
          this.companyAddress = response.company.company_address;
          this.phoneNoFaxNo =
            (response.company.company_phone_number == "" ||
            response.company.company_phone_number == null
              ? "N/A"
              : response.company.company_phone_number) +
            " / " +
            (response.company.company_fax_number == "" ||
            response.company.company_fax_number == null
              ? "N/A"
              : response.company.company_fax_number);
          this.picFullName = response.pic.user_name;
          this.picPhoneNoFaxNo =
            (response.pic.pic_phone_number == "" ||
            response.pic.pic_phone_number == null
              ? "N/A"
              : response.pic.pic_phone_number) +
            " / " +
            (response.pic.pic_fax_number == "" ||
            response.pic.pic_fax_number == null
              ? "N/A"
              : response.pic.pic_fax_number);
          this.picEmail = response.pic.user_email;

          this.shipName = response.ship.ship_name;
          this.imoNo = response.ship.imo_number;
          this.shipType = response.ship.ship_type_name;
          this.grossTonnage = response.ship.gross_tonnage;
          this.deadweightTonnage = response.ship.deadweight_tonnage;
          this.owneroperatorname = response.ship.operator_name;
          this.callSign = response.ship.call_sign;
          this.flagState = response.ship.country_name;
          // this.sustainableCertificates =
          // response.ship.documents == null ? "None" : response.ship.documents;

          if (response.ship.documents != null) {
            for (var i = 0; i < response.ship.documents.length; i++) {
              let obj = {
                filename: response.ship.documents[i].meta.filename,
                fileid: response.ship.documents[i].ship_document_id,
                fileurl: response.ship.documents[i].url,
              };
              this.shipdoc.push(obj);
            }
          }

          if (response.quotation != null) {
            this.ddate = response.quotation.issued_at;
            this.subjectline = response.quotation.subject_line;
            this.deliveryterm = response.quotation.delivery_term;
            this.deliverytermunit = response.quotation.delivery_term_unit;
            this.selects.day = response.quotation.delivery_term_unit;
            this.paymentterm = response.quotation.payment_term;
            this.validity = response.quotation.validity;
            this.remark1 =
              response.quotation.remarks == ""
                ? "-"
                : response.quotation.remarks;
            this.internalremark =
              response.quotation.internal_remarks == ""
                ? "-"
                : response.quotation.internal_remarks;
            console.log(this.deliverytermunit);
            console.log(this.selects.day);
          }

          let formatter = new Intl.NumberFormat("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });

          // waste detail
          for (var i = 0; i < response.waste_detail.length; i++) {
            let amount =
              response.waste_detail[i].rate *
              response.waste_detail[i].estimated_quantity;
              console.log(amount)
              console.log(formatter.format(amount))
            // var amount1 = amount.toFixed(2);

            // var parts = amount1.toString().split(".");
            // var amount3 =
            //   parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
            //   (parts[1] ? "." + parts[1] : "");

            let obj = {
              id: response.waste_detail[i].waste_detail_id,
              description: response.waste_detail[i].waste_type_name,
              wastesubtype:
                response.waste_detail[i].waste_type_sub_name == ""
                  ? "-"
                  : response.waste_detail[i].waste_type_sub_name,
              rate: formatter.format(response.waste_detail[i].rate),
              estamount: formatter.format(
                response.waste_detail[i].estimated_quantity
              ),
              // +
              // " " +
              // response.waste_detail[i].estimated_quantity_unit,
              estunit: response.waste_detail[i].estimated_quantity_unit,
              amount: formatter.format(amount),
              transportationrate: formatter.format(
                response.waste_detail[i].transport_rate
              ),
            };
            this.quotations.push(obj);
            
            this.total += amount;
            this.total += response.waste_detail[i].transport_rate;
            console.log("kadg", this.total);
          }
          
          // this.total = this.total.toFixed(2);
          // var partss = this.total.toString().split(".");
          console.log("kaeeg", this.total);

          // this.total =
          //   partss[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
          //   (partss[1] ? "." + parts[1] : "");
          console.log("rkag", this.total);

          let ground = {
            id: "",
            description: "GRAND TOTAL",
            rate: "",
            estamount: "",
            amount: formatter.format(this.total),
          };
          this.quotations.push(ground);
          
          console.log("kag", this.total);

          // files
          if (response.quotation != null) {
            if (response.quotation.quotation_support_document != null) {
              for (
                var i = 0;
                i < response.quotation.quotation_support_document.length;
                i++
              ) {
                let obj = {
                  filename:
                    response.quotation.quotation_support_document[i].filename,
                  fileid:
                    response.quotation.quotation_support_document[i]
                      .quotation_support_document_id,
                };
                this.allfilename.push(obj);
              }
            }
          }
        }
      });
    },
    saveDraft() {
      // arrange waste details array
      let wastedetails = [];
      for (var i = 0; i < this.quotations.length; i++) {
        if (this.quotations[i].description != "GRAND TOTAL") {
          let wasteObj = {
            waste_detail_id: this.quotations[i].id,
            rate: parseFloat(this.quotations[i].rate),
            transport_rate: parseFloat(this.quotations[i].transportationrate),
          };
          wastedetails.push(wasteObj);
        }
        // let wasteObj = {
        //   waste_detail_id: this.quotations[i].id,
        //   rate: parseFloat(this.quotations[i].rate),
        // };
        // wastedetails.push(wasteObj);
      }
      let obj = {
        subject_line: this.subjectline,
        description: "",
        rate_term: "KG",
        delivery_term: this.deliveryterm,
        delivery_term_unit: this.selects.day,
        payment_term: this.paymentterm,
        remarks: this.remark1,
        validity: this.validity,
        waste_detail: wastedetails,
        internal_remarks: this.internalremark,
      };

      console.log("quo obj", obj);

      this.$http
        .put(":10001/api/v1/incoming/" + this.jobno + "/quotation", obj)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            swal({
              title: `Success!`,
              text: `Quotation draft saved!`,
              buttonsStyling: false,
              confirmButtonClass: "btn btn-primary btn-fill",
              type: "success",
            }).then((result) => {
              console.log(result);
              if (result.value == true) {
                this.$router.push("/Incoming");
              }
            });
            this.getDetail();
          }
        });
    },
    generateQuotation() {
      let wastedetails = [];

      if (
        this.subjectline != "" &&
        this.deliveryterm != "" &&
        this.paymentterm != "" &&
        this.validity != ""
      ) {
        // arrange waste details array
        for (var i = 0; i < this.quotations.length; i++) {
          // console.log()
          if (this.quotations[i].description != "GRAND TOTAL") {
            let wasteObj = {
              transport_rate: parseFloat(this.quotations[i].transportationrate),
              waste_detail_id: this.quotations[i].id,
              rate: parseFloat(this.quotations[i].rate),
            };
            wastedetails.push(wasteObj);
          }
        }
        let obj = {
          subject_line: this.subjectline,
          description: "",
          rate_term: "KG",
          delivery_term: this.deliveryterm.toString(),
          delivery_term_unit: this.selects.day,
          payment_term: this.paymentterm.toString(),
          remarks: this.remark1,
          validity: this.validity.toString(),
          waste_detail: wastedetails,
          internal_remarks: this.internalremark,
        };

        console.log("obj", obj);

        this.$http
          .post(":10001/api/v1/incoming/" + this.jobno + "/quotation", obj)
          .then((res) => {
            if (!res.error) {
              let response = res.message;

              this.getPDF();
              this.modals.generate = true;
              setTimeout(() => {
                this.modals.generate = false;
              }, 1500);
              this.getDetail();

              this.generate = true;
            }
          });
      } else {
        if (this.subjectline == "") {
          swal({
            title: `Info!`,
            text: "Subject line is required!",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-primary btn-fill",
            type: "warning",
          });
        }

        if (this.deliveryterm == "") {
          swal({
            title: `Info!`,
            text: "Delivery term is required!",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-primary btn-fill",
            type: "warning",
          });
        }

        if (this.paymentterm == "") {
          swal({
            title: `Info!`,
            text: "Payment term is required!",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-primary btn-fill",
            type: "warning",
          });
        }

        if (this.validity == "") {
          swal({
            title: `Info!`,
            text: "Validity is required!",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-primary btn-fill",
            type: "warning",
          });
        }
      }
    },
    nextTab() {
      let parameter = {
        step: "2",
        direction: "depan",
        data: [],
      };
      this.$emit("my-event", parameter);
    },
    prevTab() {
      let parameter = {
        step: "2",
        direction: "blkg",
        data: [],
      };
      this.$emit("my-event", parameter);
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        let style = { background: "#FFFFFF", color: "#15cf79" };
        return style;
      } else {
        let style = { background: "#f5f6fa", color: "#959595" };
        return style;
      }
    },
    onFileChange(event) {
      console.log(event);
      const t = event.target;
      for (let i = 0; i < t.files.length; i++) {
        console.log(t.files[i]);
        this.docs = t.files[i];
        const formData = new FormData();
        formData.append("document", this.docs);

        this.$http
          .post(
            ":10001/api/v1/incoming/" +
              this.jobno +
              "/quotation/quotation-document",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: "Bearer " + sessionStorage.getItem("token"),
              },
            }
          )
          .then((res) => {
            if (!res.error) {
              let response = res.message;
              console.log(response);
              swal({
                title: `Success!`,
                text: response,
                buttonsStyling: false,
                confirmButtonClass: "btn btn-primary btn-fill",
                type: "success",
              });
              this.getDetail();
              this.uploadload = false;
            }
          });
      }
    },
    removeFile(fileid) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value == true) {
          this.$http
            .delete(
              ":10001/api/v1/incoming/" + this.jobno + "/quotation/" + fileid
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                swal({
                  title: `Success!`,
                  text: response,
                  buttonsStyling: false,
                  confirmButtonClass: "btn btn-primary btn-fill",
                  type: "success",
                });
                this.getDetail();
                this.generate = true;
              }
            });
        }
      });
    },
    getJobPage() {
      this.generate = false;
    },

    validate() {
      return this.$validator.validateAll().then((res) => {
        this.$root.$emit("image", this.imagebase64);
        return res;
      });
    },
  },
};
</script>
<style scoped>
textarea {
  width: 100%;
  height: 350px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 1px solid #2b3553;
  border-radius: 4px;
  background-color: transparent;
  font-size: 14px;
  resize: none;
  /* color: #1d253b; */
}

textarea:focus {
  outline: none !important;
  border: 1px solid #1d8cf8;
  transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out,
    background-color 0.3s ease-in-out;
}

.address {
  width: 100%;
  height: 100px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 14px;
  resize: none;
}

.huraian {
  width: 100%;
  height: 350px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 14px;
  resize: none;
}

.new-title {
  margin-top: 20px;
  color: #A5A5A5;
}

.subtitle {
  color: #A5A5A5;
  text-align: left;
  font-weight: 600;
  font-size: 18px;
}

.sub-title {
  text-decoration: underline;
  color: #A5A5A5;
  text-align: left;
  font-weight: 600;
  font-size: 18px;
}

.scrollable {
  height: 500px;
  overflow-y: scroll;
  padding: 0px 0px 0px 30px;
  color: #A5A5A5;
}

.newtitle {
  color: #707070;
  text-align: left;
  font-weight: 600;
  font-size: 18px;
}

.sub-titles {
  margin-top: -5px;
  color: #A5A5A5;
}

/* width */
::-webkit-scrollbar {
  width: 10px;
  height: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #dce9ff;
  border-radius: 15px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #5e99ff;
  border-radius: 15px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #176bfd;
}

.el-table {
  word-break: break-word !important;
}
</style>
